import OEReportsChart from '../../pages/OEReportsChart';
import MCReportsChart from '../../pages/MCReportsChart';
import SDReportsChart from '../../pages/SDReportsChart';
import PPReportsChart from '../../pages/PPReportsChart';
import ESDReportsChart from '../../pages/ESDReportsChart';
import SEDReportsChart from '../../pages/SEDReportsChart';

// Maps a scorecard element group to the consultant report/chart component for it.
const MAP = {
  ownership: OEReportsChart,
  management_control: MCReportsChart,
  management_control_transport: MCReportsChart,
  employment_equity: MCReportsChart,
  skills_development: SDReportsChart,
  skills_development_transport: SDReportsChart,
  skills_development_specialised: SDReportsChart,
  preferential_procurement: PPReportsChart,
  enterprise_supplier_development: ESDReportsChart,
  enterprise_development_transport: ESDReportsChart,
  sed: SEDReportsChart,
  sed_transport: SEDReportsChart,
};

export const reportChartFor = (groupKey) => MAP[groupKey] || null;

// Distinct chart components for a set of group keys, in order (deduped).
export const reportChartsFor = (groupKeys) => {
  const seen = new Set();
  const out = [];
  groupKeys.forEach((k) => {
    const C = MAP[k];
    if (C && !seen.has(C)) { seen.add(C); out.push({ key: k, Chart: C }); }
  });
  return out;
};
